<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">

      <!-- 新增模式下才显示门店选择和商品选择 -->
      <template v-if="formType === 1">
        <a-form-model-item :label="$t('秒杀库存.门店')" prop="shopIds">
          <a-select v-model="form.shopIds" mode="multiple" placeholder="请选择门店（可多选）" allow-clear @change="handleShopChange">
            <a-select-option v-for="shop in shopList" :key="shop.id" :value="shop.id">
              {{ shop.shopName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item :label="$t('通用.文本.选择商品')" prop="goodsId">
          <a-button type="dashed" @click="openProdSelect" danger>
            <span style="color: dodgerblue"> {{$t('通用.文本.选择商品')}}</span>
          </a-button>
        </a-form-model-item>

        <!-- 商品信息展示 -->
        <a-row>
          <a-col :span="24">
            <a-table
              v-if="form.goodsList.length > 0"
              :loading="goodsLoading"
              rowKey="id"
              :size="tableSize"
              :columns="goodsColumns"
              :data-source="form.goodsList"
              :pagination="false"
              :bordered="tableBordered"
              style="margin-bottom: 20px; width: 80%;">
              <template slot="picture" slot-scope="text, record">
                <div>
                  <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
                </div>
              </template>
            </a-table>
          </a-col>
        </a-row>
      </template>

      <!-- SKU积分价格设置 -->
      <a-row v-if="form.goodsId || (formType === 2 && skuList.length > 0)">
        <a-col :span="24">
          <div style="margin-bottom: 10px; font-weight: bold;">SKU积分价格设置</div>
          <template v-if="skuList && skuList.length > 0">
            <a-alert message="请为每个SKU设置积分价格,积分价格必须大于0" type="info" style="margin-bottom: 10px;" show-icon />
            <a-table
              :loading="goodsLoading"
              rowKey="id"
              :size="tableSize"
              :columns="skuColumns"
              :data-source="skuList"
              :pagination="false"
              :bordered="tableBordered"
              style="width: 80%"
            >
              <template slot="picture" slot-scope="text, record">
                <div>
                  <img v-if="record.picture" :src="record.picture" style="width:40px;height:40px;" @click="handleRecordPreview(record.picture)" alt="none"/>
                </div>
              </template>
              <template slot="pointPrice" slot-scope="text, record">
                <a-input-number
                  v-model="record.pointPrice"
                  :min="0"
                  :precision="0"
                  placeholder="请输入积分价"
                  style="width: 100%"
                  @change="limitPointPrice(record)"
                />
              </template>
              <template slot="skuStock" slot-scope="text, record">
                <span>{{ record.stock || 0 }}</span>
              </template>
            </a-table>
          </template>
          <a-alert v-else-if="formType === 1" message="请先选择商品" type="warning" />
        </a-col>
      </a-row>

      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
      <!-- 新增模式才需要商品选择组件 -->
      <radio-goods-select-form ref="RadioGoodsSelectForm" @goodsSelect="indexGoodsModalSelect" v-if="formType === 1"></radio-goods-select-form>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getGoods, addGoods, updateGoods, copyFromNormalGoods, editPointPrice, getSkuListByPointGoodsId, getSelectableShops } from '@/api/goodspoint/goodspoint'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import RadioGoodsSelectForm from "@/views/goods/point/modules/RadioSelectForm";
import {listCategory} from "@/api/goods/category";
import {allBrand} from "@/api/goods/brand";
import { getGoods as getNormalGoods, querySkuByGoodsId } from '@/api/goods/goods'


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    RadioGoodsSelectForm,
  },
  data () {
    return {
      goodsLoading: false,
      shopList: [], // 门店列表
      categoryList: [], // 分类列表
      brandList: [], // 品牌列表

      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      loading: '',
      skuList: [], // 商品SKU列表
      goodsColumns: [
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          width: 120,
        },
        {
          title: '商品主图',
          dataIndex: 'picture',
          width: 70,
          scopedSlots: {customRender: 'picture'},
        },
        // {
        //   title: '市场价',
        //   width: 80,
        //   dataIndex: 'marketPrice',
        // },
        {
          title: '商品价',
          width: 80,
          dataIndex: 'price',
        },
      ],
      skuColumns: [
        {
          title: 'SKU名称',
          dataIndex: 'skuName',
          width: 100,
          ellipsis: true
        },
        {
          title: 'SKU图片',
          dataIndex: 'picture',
          width: 60,
          align: 'center',
          scopedSlots: {customRender: 'picture'},
        },
        {
          title: '原价',
          dataIndex: 'price',
          width: 70,
          align: 'center'
        },
        {
          title: '库存',
          dataIndex: 'stock',
          width: 60,
          align: 'center',
          scopedSlots: {customRender: 'skuStock'},
        },
        {
          title: '积分价',
          dataIndex: 'pointPrice',
          width: 110,
          align: 'center',
          scopedSlots: {customRender: 'pointPrice'},
        },
      ],
      // 表单参数
      form: {
        id: null,
        goodsList: [],
        shopIds: [],
        goodsId: null,
        goodsName: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        // 新增模式下的验证规则
        shopIds: [
          { required: true, type: 'array', min: 1, message: '请至少选择一个门店', trigger: 'change' }
        ],
        goodsId: [
          { required: true, message: '请选择商品', trigger: 'change' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
    this.getCateList();
    this.getBrandList();
    this.getShopList();
  },
  computed: {
    ...mapGetters(['customDict', 'tableSize', 'tableBordered'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    getCateList() {
      listCategory().then(response => {
        this.categoryList = response.data;
      })
    },
    getBrandList() {
      allBrand().then(response => {
        this.brandList = response.data
      })
    },
    getShopList() {
        // 根据当前登录用户角色获取可创建积分商品的门店：平台所有门店/商家名下门店/门店自身
      getSelectableShops().then(response => {
        this.shopList = response.data || []
      }).catch(() => {
        this.shopList = []
      })

    },
    handleShopChange(value) {
      // 门店改变时,清空已选择的商品和SKU
      if (this.form.goodsId) {
        this.form.goodsId = null
        this.form.goodsList = []
        this.skuList = []
      }
    },
    getBrandNameById(id) {
      if (!id) {
        return "";
      }
      let brandInfo = this.brandList.find(e => e.id === id);
      if (brandInfo) {
        return brandInfo.name
      } else {
        return "";
      }
    },
    getCategoryNameById(id) {
      if (!id) {
        return "";
      }
      let cateInfo = this.categoryList.find(e => e.id === id);
      if (cateInfo) {
        return cateInfo.categoryName
      } else {
        return "";
      }
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        goodsList: [],
        id: null,
        shopIds: [],
        goodsId: null,
        goodsName: null,
      }
      this.skuList = []
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getGoods({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')

        // 编辑积分商品时,直接查询积分商品自己的SKU列表
        this.loadPointGoodsSku(response.data.id)
      })
    },
    indexGoodsModalSelect(records) {
      this.form.goodsId = records[0].id
      this.form.goodsList = records
      console.log('商品选择了',this.form.goodsList)
      // 加载商品SKU列表
      this.loadGoodsSku(records[0].id)
    },
    openProdSelect() {
      if (!this.form.shopIds || this.form.shopIds.length === 0) {
        this.$message.warning('请先选择门店')
        return
      }
      // 多选门店时,以第一个选中门店作为商品检索条件(仅用于展示商品列表)
      const firstShopId = this.form.shopIds[0]
      console.log('打开商品选择框,单选模式,门店ID:', firstShopId)
      this.$refs.RadioGoodsSelectForm.openGoods(firstShopId, [this.form.goodsId]);
    },
    /** 提交按钮 */
    submitForm: function () {
      // 编辑模式下不需要验证表单,直接提交
      if (this.formType === 2) {
        this.submitEditForm()
        return
      }

      // 新增模式下需要验证表单
      this.$refs.form.validate(valid => {
        if (valid) {
          // 校验SKU积分价
          if (!this.skuList || this.skuList.length === 0) {
            this.$message.warning('请选择商品')
            return
          }
          const hasEmptyPointPrice = this.skuList.some(sku => !sku.pointPrice || sku.pointPrice <= 0)
          if (hasEmptyPointPrice) {
            this.$message.warning('请为所有SKU设置积分价')
            return
          }

          this.submitLoading = true
          const message = this.$t('通用.文本.添加成功')
          const addData = {
            sourceGoodsId: this.form.goodsId,
            shopIds: this.form.shopIds,
            skuPointPrices: this.skuList.map(sku => ({
              sourceSkuId: sku.id,
              pointPrice: sku.pointPrice
            }))
          }
          copyFromNormalGoods(addData).then(response => {
            this.$message.success(message, 3)
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    },
    submitEditForm() {
      // 编辑模式 - 只提交积分价格
      // 校验SKU积分价
      if (!this.skuList || this.skuList.length === 0) {
        this.$message.warning('SKU列表不能为空')
        return
      }
      const hasEmptyPointPrice = this.skuList.some(sku => !sku.pointPrice || sku.pointPrice <= 0)
      if (hasEmptyPointPrice) {
        this.$message.warning('请为所有SKU设置积分价')
        return
      }

      this.submitLoading = true
      const message = this.$t('通用.文本.修改成功')
      const editData = {
        pointGoodsId: this.form.id,
        skuPointPrices: this.skuList.map(sku => ({
          skuId: sku.id,
          pointPrice: sku.pointPrice
        }))
      }
      editPointPrice(editData).then(response => {
        this.$message.success(message, 3)
        this.open = false
        this.$emit('ok')
      }).finally(() => {
        this.submitLoading = false
      })
    },
    loadGoodsSku(goodsId) {
      console.log('开始加载SKU列表, goodsId:', goodsId)
      if (!goodsId) {
        this.skuList = []
        this.goodsLoading = false
        return
      }
      this.goodsLoading = true

      // 并行加载SKU列表和商品详情
      Promise.all([
        querySkuByGoodsId(goodsId),
        getNormalGoods({ id: goodsId })
      ]).then(([skuResponse, goodsResponse]) => {
        console.log('获取SKU列表成功:', skuResponse.data)
        console.log('获取商品详情成功:', goodsResponse.data)

        const skuList = skuResponse.data || []
        const goodsDetail = goodsResponse.data || {}
        const specList = goodsDetail.specList || []

        // 创建规格值ID到规格名称的映射
        const specValueMap = {}
        specList.forEach(spec => {
          if (spec.specValueList) {
            spec.specValueList.forEach(specValue => {
              specValueMap[specValue.id] = {
                specName: spec.specName,
                specValueName: specValue.specValueName
              }
            })
          }
        })
        console.log('规格值映射:', specValueMap)

        this.skuList = skuList.map(sku => {
          // 解析specValueIds (格式可能是 "id1:id2:id3")
          let skuName = sku.skuName || ''
          if (sku.specValueIds) {
            const specValueIdArray = sku.specValueIds.split(':')
            const specNameArray = []
            specValueIdArray.forEach(id => {
              const specInfo = specValueMap[id]
              if (specInfo) {
                specNameArray.push(`${specInfo.specName}:${specInfo.specValueName}`)
              }
            })
            if (specNameArray.length > 0) {
              skuName = specNameArray.join(' ')
            }
          }

          return {
            id: sku.id,
            skuId: sku.id,
            skuName: skuName,
            specValueIds: sku.specValueIds || '',
            picture: sku.picture || '',
            price: sku.price || 0,
            stock: sku.stock || 0,
            pointPrice: sku.pointPrice || null
          }
        })
        console.log('SKU处理后数据:', this.skuList)
      }).catch(error => {
        console.error('加载SKU列表失败:', error)
        this.skuList = []
      }).finally(() => {
        this.goodsLoading = false
      })
    },
    loadPointGoodsSku(pointGoodsId) {
      console.log('开始加载积分商品SKU列表, pointGoodsId:', pointGoodsId)
      if (!pointGoodsId) {
        this.skuList = []
        this.goodsLoading = false
        return
      }
      this.goodsLoading = true

      // 直接查询积分商品的SKU列表
      getSkuListByPointGoodsId(pointGoodsId).then(response => {
        console.log('获取积分商品SKU列表成功:', response.data)
        const skuList = response.data || []

        this.skuList = skuList.map(sku => {
          return {
            id: sku.id,
            skuId: sku.id,
            skuName: sku.skuName || '',
            specValueIds: sku.specValueIds || '',
            picture: sku.picture || '',
            price: sku.price || 0,
            stock: sku.stock || 0,
            pointPrice: sku.pointPrice || null
          }
        })
        console.log('积分商品SKU处理后数据:', this.skuList)
      }).catch(error => {
        console.error('加载积分商品SKU列表失败:', error)
        this.skuList = []
      }).finally(() => {
        this.goodsLoading = false
      })
    },
    limitPointPrice(sku) {
      let val = sku.pointPrice
      if (val == null || val == undefined || val === '') {
        sku.pointPrice = null
        return
      }
      if (val < 0) {
        sku.pointPrice = 0
      }
      if (val > 2147483647) {
        sku.pointPrice = 2147483647
      }
    },
  }
}
</script>
